<template>
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-lg-2 q-pa-sm">
      <q-card :class="genderClass()">
        <q-card-section>
          <div class="text-subtitle2"><q-icon name="people" /> cinsiyet</div>
          <div class="text-h6">{{ mappers.genderMapper(customer.gender) }}</div>
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 col-sm-6 col-lg-2 q-pa-sm">
      <q-card :class="genderClass()">
        <q-card-section>
          <div class="text-subtitle2"><q-icon name="phone" /> telefon</div>
          <div class="text-h6">{{ customer.phone }}</div>
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 col-sm-6 col-lg-2 q-pa-sm">
      <q-card :class="genderClass()">
        <q-card-section>
          <div class="text-subtitle2"><q-icon name="email" /> e-posta</div>
          <div class="text-h6">{{ customer.email }}</div>
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 col-sm-6 col-lg-2 q-pa-sm">
      <q-card :class="genderClass()">
        <q-card-section>
          <div class="text-subtitle2"><q-icon name="event" /> dogum</div>
          <div class="text-h6">
            {{ timetravel.fromYearMonthDayToReverse(customer.birthday) }} ({{
              moment().diff(moment(customer.birthday), 'year')
            }})
          </div>
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 col-sm-6 col-lg-2 q-pa-sm">
      <q-card :class="genderClass()">
        <q-card-section>
          <div class="text-subtitle2"><q-icon name="favorite" /> medikal</div>
          <div v-for="med in customer.medical" :key="med" class="text-h6">
            * {{ med }}
          </div>
        </q-card-section>
      </q-card>
    </div>
    <div class="col-xs-12 col-sm-6 col-lg-2 q-pa-sm">
      <q-card :class="genderClass()">
        <q-card-section>
          <div class="text-subtitle2"><q-icon name="paid" /> aktif paket</div>
          <div
            v-for="subs in customer.activeSubscriptions"
            :key="subs.id"
            class="text-h6"
          >
            {{ subs.subscriptionTitle }}
          </div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>
<script>
import { toRefs } from 'vue'
import * as mappers from '../../utils/mapper'
import * as timetravel from '../../utils/timetravel'
import moment from 'moment'
export default {
  props: {
    customer: Object,
  },
  setup(props) {
    let { customer } = toRefs(props)

    function genderClass() {
      return customer.value.gender === 'MALE'
        ? 'bg-indigo text-white'
        : 'bg-pink text-white'
    }
    return {
      moment,
      mappers,
      timetravel,
      genderClass,
    }
  },
}
</script>
